import React, { useEffect, useState } from 'react'
import { t } from 'i18next'
import { Accordion } from '@awell/ui-kit/components/Accordion'
import { GeneratedClinicalNote } from '../../../../hooks/useClinicalNote/types'
import { Activity } from '../../types'
import { Button } from '@awell-health/design-system'

interface NarrativesTabProps {
  activity: Activity
  clinicalNote?: GeneratedClinicalNote
}

export const NarrativesTab = ({ activity, clinicalNote }: NarrativesTabProps): JSX.Element => {
  const [expanded, setExpanded] = useState<Array<string>>([])

  const getAllNarrativesIds = (): Array<string> => {
    return clinicalNote!.narratives.map(({ id }) => id)
  }
  const handleChange = (panelId: string) => {
    const isExpanded = expanded.includes(panelId)

    const newData = !isExpanded ? [...expanded, panelId] : expanded.filter(id => id !== panelId)
    setExpanded(newData)
  }

  const handleManageAll = () => {
    if (expanded.length > 0) {
      setExpanded([])
      return
    }
    const allIds = getAllNarrativesIds()
    setExpanded(allIds)
  }

  useEffect(() => {
    const allIds = getAllNarrativesIds()
    setExpanded(allIds)
  }, [])

  return (
    <div>
      <div className="flex justify-end mb-4">
        <Button variant="secondaryBlue" onClick={handleManageAll} size="sm">
          {expanded.length > 0 ? t('collapse_all') : t('expand_all')}
        </Button>
      </div>

      {clinicalNote!.narratives.map(({ title, body, id }) => {
        const isExpanded = expanded.includes(id)
        return (
          <div key={`${activity.id}-${id}`} className="mb-4">
            <Accordion title={title} body={body} id={id} expanded={isExpanded} onExpandToggle={handleChange} />
          </div>
        )
      })}
    </div>
  )
}

NarrativesTab.displayName = 'NarrativesTab'
